import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Plus, X } from "lucide-react";

export const TemplateEditor = () => {
    const [tpls, setTpls] = useState(null);
    const [sel, setSel] = useState(0);
    const [draft, setDraft] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => { api.get("/admin/planner/templates").then((r) => { setTpls(r.data); setDraft(r.data[0]?.sections || []); }); }, []);
    if (!tpls) return <Loader2 className="animate-spin text-slate-400"/>;

    const pick = (i) => { setSel(i); setDraft(tpls[i].sections); };
    const setSec = (i, patch) => setDraft(draft.map((s, j) => (j === i ? { ...s, ...patch } : s)));
    const save = async () => {
        setBusy(true);
        try {
            const r = await api.put(`/admin/planner/templates/${tpls[sel].id}`, { sections: draft });
            setTpls(tpls.map((t, i) => (i === sel ? r.data : t)));
            toast.success("Checklist saved");
        } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
        finally { setBusy(false); }
    };

    return (
        <div data-testid="planner-template-editor">
            <p className="text-xs text-slate-500 mb-3">Each line is a generic product name. Customers see your matching items from the Item Master next to it — unmatched names can still be requested and are priced in the quotation.</p>
            <div className="flex gap-1 flex-wrap mb-4">
                {tpls.map((t, i) => (
                    <button key={t.id} onClick={() => pick(i)} data-testid={`planner-tpl-${i}`}
                            className={`px-3 py-1.5 rounded-full text-xs font-bold border ${i === sel ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200"}`}>{t.name}</button>
                ))}
            </div>
            <div className="grid md:grid-cols-2 gap-3">
                {draft.map((s, i) => (
                    <div key={i} className="hdb-card p-3" data-testid={`planner-tpl-section-${i}`}>
                        <div className="flex gap-2">
                            <input className="hdb-input font-bold" value={s.name} onChange={(e) => setSec(i, { name: e.target.value })} data-testid={`planner-tpl-section-name-${i}`}/>
                            <button className="text-slate-400 hover:text-red-600" onClick={() => setDraft(draft.filter((_, j) => j !== i))} title="Remove section"><X size={14}/></button>
                        </div>
                        <textarea rows={4} className="hdb-input mt-2 text-xs" value={s.items.join("\n")} data-testid={`planner-tpl-section-items-${i}`}
                                  onChange={(e) => setSec(i, { items: e.target.value.split("\n") })} placeholder="One product per line"/>
                    </div>
                ))}
            </div>
            <div className="flex gap-2 mt-4">
                <button className="hdb-btn hdb-btn-ghost" onClick={() => setDraft([...draft, { name: "New section", items: [] }])} data-testid="planner-tpl-add-section"><Plus size={12}/> Section</button>
                <button className="hdb-btn hdb-btn-primary" disabled={busy} onClick={save} data-testid="planner-tpl-save">Save checklist</button>
            </div>
        </div>
    );
};
